import { theme } from 'aimo-ui';
import MenuItem from 'components/common/MenuItem';
import PermitAvailability from 'components/longTermParking/waitingList/PermitAvailability';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParkzoneStore } from 'stores/parkzoneStore';
import { ColumnWithMargins } from 'styles/ContainerStyles';
import { Pmc, ReservedParkingSpace } from 'types/generatedSchemaTypes';
import { getEffectiveVisibility, isPmcAvailable } from 'utils/permitUtils';

type ReservedPermitsProps = {
  parkingSpaces: ReservedParkingSpace[];
  priceLabel: string;
  pmcId: string;
  name: string;
  testID?: string;
  handleNavigate: (
    pmcId: string,
    notAvailable: boolean,
    pmcIsLockedForTheCustomer?: boolean
  ) => void;
  memberGroupName?: string;
  pmc: Pmc;
  pmcIsLockedForTheCustomer?: boolean;
  pmcIsInsideALockedMemberGroup?: boolean;
  disabled?: boolean;
};

const ReservedPermits = ({
  parkingSpaces = [],
  priceLabel,
  name,
  testID,
  handleNavigate,
  pmcId,
  memberGroupName,
  pmc,
  pmcIsLockedForTheCustomer,
  pmcIsInsideALockedMemberGroup,
  disabled,
}: ReservedPermitsProps) => {
  const { t } = useTranslation();

  const { permitNotAvailable: notAvailable } = isPmcAvailable(pmc);
  const { visibility } = pmc;
  const effectiveVisibility = getEffectiveVisibility(
    pmcIsLockedForTheCustomer,
    visibility,
    pmcIsInsideALockedMemberGroup
  );

  const Availability = useMemo(
    () => (
      <PermitAvailability
        pmc={pmc}
        pmcIsLockedForTheCustomer={pmcIsLockedForTheCustomer}
        pmcIsInsideALockedMemberGroup={pmcIsInsideALockedMemberGroup}
      />
    ),
    [pmc, pmcIsLockedForTheCustomer, pmcIsInsideALockedMemberGroup]
  );

  const handleNavigation = () => {
    useParkzoneStore.getState().setSelectedParkingSpaces(parkingSpaces);
    handleNavigate(pmcId, notAvailable, pmcIsLockedForTheCustomer);
  };

  return (
    <ColumnWithMargins mb={20}>
      <MenuItem
        testID={testID}
        menuLabel={name}
        withArrow
        noBorder
        subtitle={
          effectiveVisibility === 'LOCKED'
            ? t('permit.unlockPMC.unlockToSeePrice')
            : priceLabel
        }
        onPress={handleNavigation}
        background={theme.colors.gray50}
        disabled={notAvailable || disabled}
        bottomPillText={memberGroupName}
        rightComponent={Availability}
        visibility={effectiveVisibility ?? undefined}
      />
    </ColumnWithMargins>
  );
};

export default ReservedPermits;
